/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import { types, applySnapshot, getSnapshot } from 'mobx-state-tree';
import { toJS } from 'mobx';
import Framework from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';

const GraphListModel = types
  .model('GraphListModel', {
    graphs: types.optional(types.array(types.frozen()), []),
    error: types.maybeNull(types.string)
  })
  .views((self) => ({
    get graphListData() {
      return {
        graphs: toJS(self.graphs),
        error: self.error
      };
    }
  }))
  .actions((self) => ({
    // Fetch graphs list
    getGraphs(payload) {
      applySnapshot(self.graphs, []);
      Framework.getEventManager().publish(constants.GET_GRAPHS, { payload });
    },

    // Set graphs response
    setGraphs(data) {
      applySnapshot(self.graphs, data?.graphs || []);
      Framework.getEventManager().publish(constants.GET_GRAPHS_SUCCESS, { graphs: data?.graphs || [] });
    },

    // Set error
    setError(errorMessage) {
      applySnapshot(self.error, errorMessage);
      Framework.getEventManager().publish(constants.GET_GRAPHS_ERROR, { error: errorMessage });
    },

    // Reset state
    resetState() {
      applySnapshot(self, {
        ...getSnapshot(self),
        graphs: [],
        error: null
      });
    }
  }));

export default GraphListModel;
